import {LogItemTitleItemType} from '@toolify/client/src/modules/activity/enum/LogItemTitleItemType'
import {LogTitleItem} from '@toolify/client/src/modules/activity/types/ILogTitleItem'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {i18n} from '@toolify/client/src/setup/i18n'
import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'
import {getNotificationThemeVariable} from './getNotificationThemeVariable'

const {t} = i18n.global

export function shouldInlineNotificationResourceInTitle(): boolean {
  return !getNotificationThemeVariable(ThemeVariableType.ShowNotificationResourceSpace)
}

export function buildInlineNotificationResourceTitleItems(
  resource: {
    text: string
    iconNameType?: IconNameType
  },
  options?: {
    /** When true, skip the "in"/"w" prefix (e.g. NewMessage already ends with "in"). */
    omitInPrefix?: boolean
  },
): LogTitleItem[] {
  if(!shouldInlineNotificationResourceInTitle()) {
    return []
  }
  const items: LogTitleItem[] = []
  if(!options?.omitInPrefix) {
    items.push({
      type: LogItemTitleItemType.String,
      payload: t('notifications.notificationItemTitleItems.in'),
    })
  }
  items.push({
    type: LogItemTitleItemType.Item,
    payload: {
      text: resource.text,
      iconNameType: resource.iconNameType,
    },
  })
  return items
}
